import { State, BP_Status } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getExecutionHistoryParsingStatus = (state: State): BP_Status => state.executionHistoryParsingStatus;

export const selectExecutionHistoryParsingStatus: MemoizedSelector<
  object,
  BP_Status
  > = createSelector(selectBpmnProcessState, getExecutionHistoryParsingStatus);
